import { BenFn } from '@/common/BenFn'
import { BenQuery } from './BenQuery'
import Splide from '@splidejs/splide'
import { BenModalFn } from '@/common/BenModalFn'
import { BenModal } from './BenModal'
let _activeDiv = null as null | HTMLElement
export class BenBbMore {
  static init(dones, app) {
    const $sw = BenQuery.query('.bb01')
    $sw.forEach(($item) => {
      if (dones.includes($item)) return
      dones.push($item)
      _init($item, app)
    })
  }
}

function _init($bb: HTMLElement, app) {
  const $btn = $bb.querySelector('.more > .btn-name') as HTMLElement
  if (!$btn) return
  const $tt = $bb.querySelector('.ct .tt') as HTMLElement | null
  const $moreContent = $bb.querySelector('.more .more-content') as HTMLElement
  if (!$moreContent) return
  const title = $tt ? $tt.textContent : ''
  $btn.addEventListener('click', async () => {
    const html = $moreContent.innerHTML
    const titleHtml = title ? `<div class="tt">${title}</div>` : ''
    const modalHtml = `${titleHtml}\n${html}`
    const isMobile = BenFn.isMobileByWidth()
    if (isMobile) {
      const $dom = document.createElement('div')
      $dom.classList.add('g011')
      $dom.innerHTML = modalHtml
      BenModal.init($dom, app)
    } else {
      const $div = document.createElement('div')
      $div.classList.add('c-win')
      $div.classList.add('g011')
      $div.classList.add('show')
      $div.innerHTML = `<div class="head">
    <span class="title moveWrap"><svg class="video-icon"><use xlink:href="#icon-menu"></use></svg></span>
    <div class="ctrlWrap control">
      <svg class="closeBtn" @click="closeChatWin" viewBox="0 0 1024 1024">
        <use xlink:href="#icon-win-close"></use>
      </svg>
    </div>
  </div>
  <div class="body">${modalHtml}</div>`
      if (_activeDiv) _activeDiv.remove()
      document.getElementsByTagName('body')[0].prepend($div)
      _activeDiv = $div
      await BenQuery.nextTick()
      const $closeBtn = $div.querySelector('.closeBtn')
      $closeBtn?.addEventListener('click', () => {
        $div.remove()
      })
      BenModalFn.init($div, {})
    }
  })
}
